// import { Silo, Food, Oil, Pharma, Moxtalef, Hararati, Textile } from "./index";
import { Box, Chip, Tooltip, Typography } from "@mui/material";
import { ArrowBackRounded } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useState } from "react";
import "./projects.css";
import Pannel from "./tabs/Pannel";
import SideBarProject from "./tabs/SideBarProject";

const MoreProjects = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <Box className="page-project">
        <Box component="div">
          <Chip
            className="chip-main"
            size="medium"
            label={
              <Typography sx={{ fontSize: "1.5rem", fontFamily: "Homa" }}>
                لیست پروژه های ایما
              </Typography>
            }
          />
          <Link to="/" component="Button">
            {/* <Typography sx={{ display: "flex" }}>صفحه نخست</Typography> */}
            <Tooltip
              title="صفحه نخست"
              sx={{ fontFamily: "Homa", fontSize: "1.2rem" }}
            >
              <ArrowBackRounded sx={{ fontSize: 38 }} className="icon-back" />
            </Tooltip>
          </Link>
        </Box>
        <Box>
          <SideBarProject
            value={value}
            handleChange={handleChange}
          ></SideBarProject>
          <Pannel value={value} handleChange={handleChange}></Pannel>
        </Box>
      </Box>
    </>
  );
};
export default MoreProjects;
